<template>
  <div>
    <div class="rj-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: 'ChiefOrderList' }">
          已办订单
        </el-breadcrumb-item>
        <el-breadcrumb-item>查看物流</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div v-loading="loading" class="rj-page-card">
      <div class="rj-page-card__title">
        合同基本信息
      </div>
      <div class="rj-page-card__content">
        <div class="rj-row">
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                供货单位(甲方)：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.supplyUnit }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                电子合同编号：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.contractNum }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                订货单位(乙方)：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.orderUnit }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                客户合同编号：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.customerContractNum }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                项目名称：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.projectName }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                最终客户：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.finalCustomer }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                订单日期：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.createTime }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                外销姓名：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.salesManName }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                售前姓名：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.preSalesName }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                首级集成商：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.integratorName }} <el-tag v-if="info.serviceSubjectCode==info.integratorCode" type="danger">
                  服务主体
                </el-tag>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                末级集成商：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.finalIntegratorsName }} <el-tag v-if="info.serviceSubjectCode==info.finalIntegratorsId" type="danger">
                  服务主体
                </el-tag>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                计量集成商：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.metrologyIntegratorName }} <el-tag v-if="info.serviceSubjectCode==info.metrologyIntegratorCode" type="danger">
                  服务主体
                </el-tag>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <rj-tabs v-model="tabsActive">
      <rj-tab-pane name="1" label="合同明细">
        <productDetail :str-contract-code="contractNum" :contract-id="info.id" />
      </rj-tab-pane>
      <rj-tab-pane name="10" label="执行订单明细">
        <contractual-product :str-contract-code="contractNum" />
      </rj-tab-pane>
      <rj-tab-pane name="7" label="约定交付日期">
        <delivery-date :str-contract-code="contractNum" />
      </rj-tab-pane>
      <rj-tab-pane name="2" label="发货明细">
        <logistics-info :str-contract-code="contractNum" />
      </rj-tab-pane>
      <rj-tab-pane name="6" label="序列号明细">
        <serial-number id="" :str-contract-code="contractNum" />
      </rj-tab-pane>
      <!--      <rj-tab-pane name="4" label="开票明细">-->
      <!--        <invoice-details :str-contract-code="contractId" />-->
      <!--      </rj-tab-pane>-->
      <!--      <rj-tab-pane name="3" label="销退明细">-->
      <!--        <extinction-details :str-contract-code="contractId" />-->
      <!--      </rj-tab-pane>-->
      <rj-tab-pane name="5" label="分配明细">
        <pay-for-details v-if="info.id" :contract-id="info.id" />
      </rj-tab-pane>
      <rj-tab-pane name="4" label="分批发货明细">
        <part-shipment v-if="info.id" :contract-id="info.id" :str-contract-code="info.contractNum" :carrier-old="info.carrier" :shipping-type-old="info.shippingType" :contract-type="info.contractType" :source-modify-address="info.sourceModifyAddress" :contract-status="info.contractStatus" />
      </rj-tab-pane>
    </rj-tabs>
  </div>
</template>
<script type="es6">
import contractualProduct from '../common/contractualProduct';
import productDetail from '../common/productDetail2';
import serialNumber from '../common/serialNumber';
import payForDetails from '../common/payForDetails';
import partShipment from '../common/partShipment.vue';
// import extinctionDetails from '../common/extinctionDetails';
// import InvoiceDetails from '../common/InvoiceDetails';
import deliveryDate from '../common/deliveryDate';
import tabs from '@/components/Tabs/tabs';
import tabPane from '@/components/Tabs/tabPane';
import logisticsInfo from '../common/logisticsInfo';
import { getContractDetailAllInfoByConNum } from '@/API';
export default {
  data () {
    return {
      tabsActive: '1',
      loading: false,
      info: {}
    };
  },
  props: {
    // 合同基本信息，该内容由路由传参过来，如果刷新该值为空，此时应当重新请求接口，获取基本信息
    contractNum: {
      type: [String, Number],
      required: true
    }
  },
  components: {
    contractualProduct,
    'rj-tab-pane': tabPane,
    'rj-tabs': tabs,
    logisticsInfo,
    serialNumber,
    payForDetails,
    deliveryDate,
    partShipment,
    productDetail
  },
  computed: {},
  methods: {
    initData () {
      this.loading = true;
      getContractDetailAllInfoByConNum(this.contractNum).then((res) => {
        let json = res.data;
        this.loading = false;
        if (json.status === '200') {
          this.info = json.data;
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    nameLocation () {
      let transact = this.$route.query.transact;
      if (transact) {
        this.tabsActive = '4';
      }
    }
  },
  mounted () {
    this.initData();
  },
  created () {
    this.nameLocation();
  }
};
</script>
